import basePath from "base_path";
import ActionTypes from "../constants/action_types";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function documentTypesFetch(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_TYPES_FETCH,
    organisationId =>
      requestor
        .get(`${basePath}/organisation/${organisationId}/document_type`, {
          withCredentials: true,
        })
        .then(response => response.data),
  );
}
